import providerFeatureManager from "@/src/services/telephony/providers/providerFeatureManager";

export default class BaseTelephonyDevice {
  constructor(provider) {
    this.provider = provider;
    this.isReady = false;
    this.currentCall = null;
  }

  async initialize(config) {
    throw new Error("initialize method must be implemented by provider");
  }

  async makeCall(params) {
    this._validateFeature("callOutbound");
    throw new Error("makeCall method must be implemented by provider");
  }

  async hangupCall() {
    throw new Error("hangupCall method must be implemented by provider");
  }

  async answerIncomingCall() {
    this._validateFeature("callInbound");
    throw new Error(
      "answerIncomingCall method must be implemented by provider",
    );
  }

  async rejectIncomingCall() {
    this._validateFeature("callInbound");
    throw new Error(
      "rejectIncomingCall method must be implemented by provider",
    );
  }

  async toColdTransfer(params) {
    this._validateFeature("coldTransfer");
    throw new Error("toColdTransfer method must be implemented by provider");
  }

  async toWarmTransfer(params) {
    this._validateFeature("warmTransfer");
    throw new Error("toWarmTransfer method must be implemented by provider");
  }

  async swapCalls() {
    this._validateFeature("callSwap");
    throw new Error("swapCalls method must be implemented by provider");
  }

  async mergeConference() {
    this._validateFeature("warmTransfer");
    throw new Error("mergeConference method must be implemented by provider");
  }

  async startRecording() {
    this._validateFeature("callRecording");
    throw new Error("startRecording method must be implemented by provider");
  }

  async stopRecording() {
    this._validateFeature("callRecording");
    throw new Error("stopRecording method must be implemented by provider");
  }

  async getVoicemails() {
    this._validateFeature("voicemails");
    throw new Error("getVoicemails method must be implemented by provider");
  }

  async purchasePhoneNumber(params) {
    this._validateFeature("purchasePhoneNumber");
    throw new Error(
      "purchasePhoneNumber method must be implemented by provider",
    );
  }

  async deletePhoneNumber(params) {
    this._validateFeature("deletePhoneNumber");
    throw new Error("deletePhoneNumber method must be implemented by provider");
  }

  getDeviceStatus() {
    throw new Error("getDeviceStatus method must be implemented by provider");
  }

  getCurrentConnection() {
    throw new Error(
      "getCurrentConnection method must be implemented by provider",
    );
  }

  getIncomingConnection() {
    throw new Error(
      "getIncomingConnection method must be implemented by provider",
    );
  }

  _validateFeature(feature) {
    try {
      providerFeatureManager.validateFeatureSupport(this.provider, feature);
    } catch (error) {
      console.warn(`Feature validation failed: ${error.message}`);
      throw error;
    }
  }

  _isFeatureAvailable(feature) {
    return providerFeatureManager.isFeatureAvailable(this.provider, feature);
  }
}
